module.exports = "/static/assets/315a5675d1738c029b0f55817c249627.png";